export const last = (length: number, value: string | undefined) => {
  const v = (value || "").padStart(8, "?")
  return v.substr(v.length - 5)
}
